import axios from 'axios';
import JustValidate from 'just-validate';
import utils from './functions-base/utils';
import consentSolution from '../../gdpr/consent-solution';

// Posthog
import ph from '../../analytics/posthog/posthog-client';

declare let core_object: any;
declare let auth_object: any;

// Utils
const modUtils = new utils();

// Consent Solution
const modConsentSolution = new consentSolution();

export default class authSignup{

    protected elWrapForm: string;
    protected elForm: string;
    protected elFormAlert: string;
    protected elFormSuccess: string = 'success_auth-register';
    protected elFormBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_register: string;

    /**
     * Constructor
     * @param elWrapForm
     * @param elForm 
     * @param elFormAlert 
     * @param elFormBtn 
     */
    constructor(
        elWrapForm: string,
        elForm: string,
        elFormAlert: string,
        elFormBtn: string
    ){
        this.elWrapForm = elWrapForm;
        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;
        this.url_api_register = auth_object.rest_urls.auth_signup;

    }

    /**
     * Init form no-obj-cons
     */
    initForm(){

        const _that = this;

        const form = document.querySelector(_that.elForm) as HTMLElement | null;

        if(form !== null){
            
            // Reset content modal
            this.resetContent();

            // Validate form
            _that.validateData();

        }
        
    }

    /**
     * Validation data
     * @returns 
     */
    protected validateData(){

        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-red-300',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 !text-red-300',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#auth_signup_email', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.email_required,
            },
            {
                rule: 'email',
                errorMessage: auth_object.error_messages.email_invalid,
            },
        ])
        .addField('#auth_signup_password', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.field_required,
            },
            {
                rule: 'strongPassword',
                errorMessage: auth_object.error_messages.strong_password,
            },
        ])
        .addField('#auth_signup_password_confirm', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.field_required,
            }
        ])
        .addField('#auth_signup_policy', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.field_required,
            }
        ])
        .addField('#auth_signup_terms_conditions', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.field_required,
            }
        ])    
        .onSuccess((event: any) => {
                
                event.preventDefault();

                // Send api
                _that.sendApi(event?.currentTarget, validation);
                
        });

        return validation;

    }

    /**
     * 
     * @param form Send Api
     */
    protected sendApi(form: HTMLFormElement, validation: JustValidate) {
        
        const _that = this;

        // Wrap form
        const wrapForm = document.querySelector(_that.elWrapForm) as HTMLElement | null;

        // Get form data
        const data = new FormData(form); 

        // Variables for Posthog
        const varsPostHog = {
            'email': data.get('auth_signup_email') as string,
        };
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button send
        const btn = document.getElementById(this.elFormBtn) as HTMLInputElement | null;

        // Init post data
        const post_data = {
            ajax_nonce: core_object.ajaxNonce,
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = modUtils.btnSpin(this.elFormSpin);

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_register, queryString)
            .then(function (response: any) {

            // Remove alert box
            modUtils.removeAlertBox(
                _that.elForm,
                _that.elFormAlert
            );
            
            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');
            
            // Response status
            let responseStatus: boolean = response.data.status;
                
            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.message;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = modUtils.alertBox(
                            _that.elFormAlert,
                            auth_object.general_message.error,
                            error
                        );
                        form?.prepend(alert);

                    });

                }else{
                    
                    const alert = modUtils.alertBox(
                        _that.elFormAlert,
                        auth_object.general_message.error,
                        errors
                    );
                    wrapForm?.prepend(alert);

                }
  
            }
            
            // True
            if(responseStatus == true){
                
                // Consent solution
                modConsentSolution.getConsent(_that.elForm);
                
                // Send event to posthog
                ph.captureSignupForm(
                    varsPostHog.email,
                );
                
                // Get message
                const message: string = response.data.message;
                
                // Create box mesaage
                const boxMessage = modUtils.successBox(
                    _that.elFormSuccess,
                    message,
                );

                // Append box message
                wrapForm?.prepend(boxMessage);

                // Reset form
                form.reset();

                // Destroy validation
                validation.destroy();

            }

        })
        .catch(function (error: any) {
            
            // Reset content modal
            _that.resetContent();

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Reset content
     */
    protected resetContent(){
        
        const el = document.querySelector(this.elForm) as HTMLElement | null;
        
        // Set disabled attribute
        el?.setAttribute('disabled', '');

        // Remove alert box
        modUtils.removeAlertBox(
            this.elForm,
            this.elFormAlert
        );

        // Remove message box
        const messageBox = document.getElementById(this.elFormSuccess) as HTMLElement | null;
        messageBox?.remove();
    
    }

}